export default __webpack_public_path__ + "static/media/NPTEL.1d8ae6d5.jpg";